import { getInvoice } from "apis/invoiceApi";
import { doCall } from "common/genericSaga";
import { downloadBlob } from "helpers/urlHelper";
import { all, call, put, takeLatest } from "redux-saga/effects";
import { INVOICE_REQUESTED, INVOICE_REQUEST_FAILED, receiveInvoice } from "./invoiceActions";

export function* doRequestInvoice(action, requestInfo) {
  const blob = yield call(getInvoice, requestInfo, action.id);
  var url = yield call(downloadBlob, blob, `invoice_${action.id}.pdf`);
  yield put(receiveInvoice(action.id, { url }));
}

export function* watchInvoice() {
  yield all([takeLatest(INVOICE_REQUESTED, doCall(doRequestInvoice, INVOICE_REQUEST_FAILED))]);
}
